import { Flex, Link as JaimyLink } from '@brand/components';
import ComponentIsVisible from 'components/utils/IsVisible';
import pages from 'constants/pages';
import { useReduxSelector } from 'hooks/redux/useReduxSelector';
import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import authSelectors from 'store/slices/auth/selectors';
import LocaleSwitcher from '../../LocaleSwitcher';
import SearchBar from '../../Searchbar';
import NavMenu from '../Menu';

const DesktopNav = () => {
  const { t } = useTranslation('common');
  const accessToken = useReduxSelector(authSelectors.accessToken);

  return (
    <>
      <ComponentIsVisible when={!!accessToken}>
        <SearchBar />
        <Flex align="center" gap={4} ml="-83px" zIndex={100}>
          <NavMenu />
          <LocaleSwitcher />
        </Flex>
      </ComponentIsVisible>

      <ComponentIsVisible when={!accessToken}>
        <Flex gap={4}>
          <Link href={pages.auth} passHref>
            <JaimyLink>{t('generic.sign_in')}</JaimyLink>
          </Link>
          <Link href={pages.help} passHref>
            <JaimyLink>{t('generic.help')}</JaimyLink>
          </Link>
          <LocaleSwitcher />
        </Flex>
      </ComponentIsVisible>
    </>
  );
};

export default DesktopNav;
